/* Product references supply current URLs. No customer tags or prices are serialized. */
(function () {
  'use strict';
  function start() {
    const node = document.getElementById('mh-member-routing-data');
    if (!node || window.mhMemberRoutingReady) return;
    let data;
    try { data = JSON.parse(node.textContent); } catch (_) { return; }
    window.mhMemberRoutingReady = true;
    function key(value) {
      if (!value) return null;
      try {
        const url = new URL(value, location.origin);
        if (url.origin !== location.origin) return null;
        const match = url.pathname.match(/\/products\/([^/]+)\/?$/);
        return match ? decodeURIComponent(match[1]) : null;
      } catch (_) { return null; }
    }
    const targets = new Map();
    const conflicts = new Set();
    const root = String(data.root || '/').replace(/\/$/, '');
    function localized(value) {
      const url = new URL(value, location.origin);
      const at = url.pathname.lastIndexOf('/products/');
      return at < 0 ? null : root + url.pathname.slice(at);
    }
    for (const group of data.groups || []) {
      const general = group.general_set || group.general;
      const member = data.segment === 'related' ? group.related :
        data.segment === 'partner' ? group.partner : null;
      // An unpublished/missing member reference falls back to a public product.
      for (const role of ['general', 'general_set', 'related', 'partner']) {
        const source = key(group[role]);
        if (!source) continue;
        let target = member;
        if (!target) target = role === 'general' || role === 'general_set' ? group[role] : general;
        if (!key(target)) continue;
        target = localized(target);
        if (targets.has(source) && targets.get(source) !== target) conflicts.add(source);
        targets.set(source, target);
      }
    }
    for (const source of conflicts) targets.delete(source);
    function destination(value) {
      const source = key(value);
      const target = targets.get(source);
      return target && key(target) !== source ? target : null;
    }
    const redirect = destination(location.href);
    if (redirect) { location.replace(redirect); return; }
    function rewrite(container) {
      container.querySelectorAll('a[href]').forEach(function (a) {
        if (a.hasAttribute('download')) return;
        const target = destination(a.href);
        if (target) a.setAttribute('href', target);
      });
    }
    rewrite(document);
    // Capture only rewrites href: preserves Ctrl/Cmd click, target and browser behavior.
    function rewriteClicked(e) {
      const a = e.target.closest && e.target.closest('a[href]');
      if (!a || a.hasAttribute('download')) return;
      const target = destination(a.href);
      if (target) a.setAttribute('href', target);
    }
    document.addEventListener('click', rewriteClicked, true);
    document.addEventListener('auxclick', rewriteClicked, true);
    document.addEventListener('shopify:section:load', function (e) { rewrite(e.target); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
